import type { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { t } from '../i18n';

/**
 * Ichki sahifalar uchun sarlavha (orqaga + nom).
 *
 * Ilgari har bir sahifa o'z sarlavhasini inline uslublar bilan qayta yozardi
 * va ular bir-biriga o'xshamasdi.
 */
export const PageHeader: FC<{
  title: string;
  subtitle?: string;
  action?: ReactNode;
}> = ({ title, subtitle, action }) => {
  const navigate = useNavigate();

  return (
    <header className="topbar">
      <div className="row" style={{ minWidth: 0 }}>
        <button
          type="button"
          className="theme-toggle"
          onClick={() => navigate(-1)}
          aria-label={t('Orqaga')}
        >
          <ChevronLeft size={19} />
        </button>
        <div style={{ minWidth: 0 }}>
          <div className="topbar-title">{title}</div>
          {subtitle && (
            <div
              className="topbar-sub"
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
      </div>
      {action}
    </header>
  );
};
